import axiosInstance from 'api/axiosInstance'
import { type FriendsQueryParameters } from 'types/api/friendship'

export const getModelFriends = async (
    modelId: string,
    params: {
        search: string
        page: number
        perPage?: number
        sort: 'asc' | 'desc'
    }
) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/friendship/model/friends/${modelId}`,
        params
    })

    return data
}

export const removeFriend = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/friendship/remove/${id}`
    })
    return data
}


export const handleFriendRequest = async (
    friendId: number,
    accept: boolean
) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/friendship/${accept ? 'accept' : 'deny'}/${friendId}`
    })
    return data
}

export const sendFriendRequest = async (id: string, message?: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/friendship/send/${id}`,
        data: {
            message
        }
    })
    return data
}
export const cancelSentFriendRequest = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/friendship/cancel-friend-request/${id}`,
        // data: {
        //     message
        // }
    })
    return data
}

export const getFriendRequests = async (params?: FriendsQueryParameters) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/friendship/pending',
        params
    })
    return data
}

export const getFriends = async (params?: FriendsQueryParameters) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/friendship/friends',
        params
    })
    return data
}
